module.exports = __webpack_public_path__ + "img/katarina_bathrooms_4.94fe2f79.jpg";